import Fetching from "@/components/Fetching/Fetching";
import { CheckCircle2, CircleX } from "lucide-react";

import classes from "./integration.module.scss";

const IntegrationSale = ({ completeOrder, completeOrderSale, completeOrderDelivery, messageOrderSale }) => {
	return (
		<div
			className={`${classes.content} ${completeOrder && completeOrderDelivery && !completeOrderSale && classes.inProcess} ${
				completeOrderSale && classes.complete
			}`}
		>
			<div>
				Obteniendo Facturas <br />
				{messageOrderSale && <small>{messageOrderSale}</small>}
			</div>
			<div>
				{completeOrder && completeOrderDelivery && !completeOrderSale && <Fetching topMargin={"0px"} />}{" "}
				{completeOrderSale && messageOrderSale === "" && <CheckCircle2 className={`${classes.checkIcon} ${classes.successIcon}`} />}
				{completeOrderSale && messageOrderSale !== "" && <CircleX className={`${classes.checkIcon} ${classes.errorIcon}`} />}
			</div>
		</div>
	);
};

export default IntegrationSale;
